import {call, put, takeLatest, select} from 'redux-saga/effects'
import Alert from 'react-s-alert';
import {defineTypes} from '../helpers'
import {reduxFetch} from '../http/reduxFetch'
import ReservationEndpoint from '../persistence/ReservationEndpoint'
import CompanyEndpoint from '../persistence/CompanyEndpoint'
import CustomerEndpoint from '../persistence/CustomerEndpoint'
import {push} from 'react-router-redux'
import * as reservation_helpers from './helpers/reservation_helpers'
import moment from 'moment'
import {reset, change} from 'redux-form'

const kegTypes = {...defineTypes('KEG_TYPES')}
const personalInformation = {...defineTypes('PERSONAL_INFORMATION')}

export const initialState = {
  step: 1,
  number_of_kegs: 1,
  hand_taps: 0,
  order: {},
  started: false,
  loading: false,
  loaded: false,
  pick_up_date: moment(),
  birthdate: moment().subtract(21, 'years'),
  return_date: moment(),
  keg_size_errors: {},
  personal_information_errors: {},
  publicInfo: {},
  preloaded_customer_info: {}
}

export const actions = {
  resetFormTwo() {
    return reset('reservation_form_two')
  },
  preloadCustomerInfo(customer_id) {
    return {type: 'PRELOAD_CUSTOMER_INFO', customer_id: customer_id}
  },
  submitFormOne(formOne, company_id) {
    return {type: 'SUBMIT_FORM_ONE', formOne: formOne, company_id: company_id}
  },
  submitFormTwo(formTwo, company_id) {
    return {type: 'SUBMIT_FORM_TWO', formTwo: formTwo, company_id: company_id}
  },
  submitDiscount(orderId, companyId) {
    return {type: 'SUBMIT_DISCOUNT', orderId: orderId, companyId: companyId}
  },
  decrementKeg() {
    return {type: 'DECREMENT_KEG'}
  },
  incrementKeg() {
    return {type: 'INCREMENT_KEG'}
  },
  decrementHandTap() {
    return {type: 'DECREMENT_HAND_TAP'}
  },
  incrementHandTap() {
    return {type: 'INCREMENT_HAND_TAP'}
  },
  handleLocationSelect(location) {
    return {type: 'LOCATION_SELECT', location: location}
  },
  handleKegSize(keg_number, keg_size_id) {
    return {type: 'KEG_SIZE_SELECT', keg_size_id: keg_size_id, keg_number: keg_number}
  },
  handleProduct(keg_number, product, company_id) {
    return {type: 'PRODUCT_SELECT', product: product, company_id: company_id, keg_number: keg_number}
  },
  unselectProduct(keg_number, product) {
    return {type: 'PRODUCT_UNSELECT', product: product, keg_number: keg_number}
  },
  setDate(date) {
    return {type: 'DATE_SELECT', date: date}
  },
  setBirthdate(date) {
    return {type: 'BIRTHDATE_SELECT', date: date}
  },
  setReturnDate(date) {
    return {type: 'RETURN_DATE_SELECT', date: date}
  },
  backOneStep() {
    return {type: 'BACK_STEP'}
  },
  killReservation() {
    return {type: 'KILL_RESERVATION'}
  },
  resetForms() {
    return {type: 'RESET_FORMS'}
  },
  publicInformation(company_id) {
    return {type: 'PUBLIC_INFORMATION', company_id: company_id}
  },
  resetErrors() {
    return {type: 'RESET_ERRORS', errors: {}}
  },
  resetKegTypeSelection(number_of_kegs) {
    return {type: 'RESET_PRODUCTS_KEG_SIZES', number_of_kegs: number_of_kegs}
  },
  cheersPage() {
    return {type: 'CHEERS_PAGE'}
  },
  verifyReservation(order_id, company_id) {
    return {type: 'VERIFY_RESERVATION', orderId: order_id, companyId: company_id}
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PRELOAD_CUSTOMER_INFO':
      return {...state, loading: true}
    case 'PRELOAD_CUSTOMER_INFO_SUCCESS':
      return {...state, loading: false, preloaded_customer_info: action.customerInfo}
    case 'PRELOAD_CUSTOMER_INFO_ERROR':
      return {...state, loading: false, errors: action.errors}
    case 'BACK_STEP':
      return (state.step > 1)
        ? {...state, step: state.step - 1}
        : {...state}
    case 'BIRTHDATE_SELECT':
      return {...state, birthdate: action.date};
    case 'RETURN_DATE_SELECT':
      return {...state, return_date: action.date}
    case 'DATE_SELECT':
      return {...state, pick_up_date: action.date, return_date: action.date}
    case 'PRODUCT_SELECT':
      return {...state, [`product_${action.keg_number}`]: action.product}
    case 'KEG_SIZE_SELECT':
      return {...state, [`keg_size_${action.keg_number}_id`]: action.keg_size_id}
    case 'PRODUCT_UNSELECT':
      return {...state, [`product_${action.keg_number}`]: {}}
    case kegTypes.REQUEST:
      return {...state, started: true, loading: true}
    case kegTypes.FAILURE:
      return {...state, loading: false, keg_size_errors: action.errors}
    case kegTypes.SUCCESS:
      return {...state, order: action.order, loading: false, started: false, step: 2}
    case personalInformation.REQUEST:
      return {...state, started: true, loading: true}
    case personalInformation.SUCCESS:
      return {
        ...state,
        order: action.order,
        order_info: action.order_info,
        loading: false,
        started: false,
        step: 3
      }
    case personalInformation.FAILURE:
      return {...state, loading: false, started: false, personal_information_errors: action.errors, step: 2}
    case 'DECREMENT_HAND_TAP':
      return (state.hand_taps > 0)
        ? {...state, hand_taps: state.hand_taps - 1}
        : {...state, hand_taps: state.hand_taps}
    case 'INCREMENT_HAND_TAP':
      return (state.hand_taps < state.number_of_kegs)
        ? {...state, hand_taps: state.hand_taps + 1}
        : {...state}
    case 'DECREMENT_KEG':
      return (state.number_of_kegs > 1)
        ? {...state, number_of_kegs: state.number_of_kegs - 1}
        : {...state, number_of_kegs: state.number_of_kegs}
    case 'INCREMENT_KEG':
      return (state.number_of_kegs < 5)
        ? {...state, number_of_kegs: state.number_of_kegs + 1}
        : {...state}
    case 'SUBMIT_FORM_ONE':
      return {...state, submitting: true}
    case 'SUBMIT_FORM_TWO':
      return {...state, submitting: true}
    case 'RESET_FORMS':
      return {...initialState}
    case 'KILL_ERROR':
      return {...initialState}
    case 'KILL_SUCCESS':
      return {...initialState}
    case 'PUBLIC_INFORMATION':
      return {...state, loading: true}
    case 'PUBLIC_INFORMATION_SUCCESS':
      return {...state, loading: false, publicInfo: action.publicInfo, pick_up_date: action.pick_up_date, return_date: action.return_date}
    case 'PUBLIC_INFORMATION_ERROR':
      return {...state, loading: false, errors: action.errors}
    case 'SUBMIT_DISCOUNT':
      return {...state, loading: true}
    case 'DISCOUNT_SUCCESS':
      return {...state, loading: false, order: action.order, order_info: action.order_info}
    case 'DISCOUNT_ERROR':
      return {...state, loading: false, errors: action.errors}
    case 'VERIFY_RESERVATION':
      return {...state, loading: true}
    case 'VERIFY_SUCCESS':
      return {...state, loading: false}
    case 'VERIFY_ERROR':
      return {...state, loading: false, errors: action.errors}
    case 'RESET_PRODUCTS_KEG_SIZES':
      let reset_product_types = {}
      let product_type_number = [...Array(action.number_of_kegs).keys()]
      product_type_number.map(keg_number => {
        reset_product_types[`product_${keg_number}`] = {}
        reset_product_types[`keg_size_${keg_number}_id`] = {}
      })
      return {...state, ...reset_product_types}
    case 'RESET_ERRORS':
      return {...state, errors: action.errors, keg_size_errors: action.errors, personal_information_errors: action.errors}
    case 'CHEERS_PAGE':
      return {...state}
    case 'LOCATION_SELECT':
      return {...state, location: action.location}
    default:
      return state
  }
}

export const selectors = {
  reservation_store: (store) => store,
  reservation: ({reservation}) => reservation,
  hand_taps: ({reservation}) => reservation.hand_taps,
  number_of_kegs: ({reservation}) => reservation.number_of_kegs,
  selected_product: (store, keg_number) => {
    return store.reservation[`product_${keg_number}`]
  },
  selected_keg_size: (store, keg_number) => {
    return store.reservation[`keg_size_${keg_number}_id`]
  },
  selectedKegSizes: (store) => {
    let num_of_kegs = store.reservation && store.reservation.number_of_kegs
    let selectedKegs = {}
    Array.from(Array(num_of_kegs), (_, i) => {
      selectedKegs[i] = (store.reservation[`product_${i}`])
    })
    return selectedKegs
  },
  form_one: (store) => {
    return store.reservation_form_one
  },
  form_two: (store) => {
    return store.form.reservation_form_two
  },
  discounts_form: (store) => {
    return store.form.discounts
  },
  pick_up_date: ({reservation}) => {return reservation.pick_up_date},
  birthdate: ({reservation}) => {return reservation.birthdate},
  return_date: ({reservation}) => {return reservation.return_date},
  order_discounts: ({reservation}) => {
    return reservation
      && reservation.order
      && reservation.order.attributes
      && reservation.order.attributes.discounts
  },
  initValues: ({reservation}) => {
    return reservation
      && reservation.order
      && reservation.order.attributes
  },
  order_id: (store) => {
    return store.reservation.order.id
  },
  order: (store) => {
    return store.reservation.order
  },
  order_info: (store) => {
    return store.reservation.order_info
  },
  keg_size_errors: (store) => {
    return store.reservation.keg_size_errors
  },
  personal_information_errors: (store) => {
    return store.reservation.personal_information_errors
  },
  publicInfo: ({reservation}) => {
    return reservation && reservation.publicInfo
  },
  company_website: ({reservation}) => {
    return reservation
      && reservation.publicInfo
      && reservation.publicInfo.attributes
      && reservation.publicInfo.attributes.website
  },
  preloadedCustomerInfo: (store) => {
    return store.reservation.preloaded_customer_info
  },
  location: ({reservation}) => {
    return reservation.location
  }
}

export function* preloadCustomerInfoSaga(action) {
  try {
    const customerInfo = yield call(reduxFetch, CustomerEndpoint.show(action.customer_id))
    if (customerInfo['data'] && customerInfo['data'].length > 0 && customerInfo['data'][0]['attributes']) {
      const customer = customerInfo.data[0].attributes
      for (var key in customer) {
        yield put(change("reservation_form_two", key, customer[key]))
      }
      yield put({
        type: 'PRELOAD_CUSTOMER_INFO_SUCCESS',
        customerInfo: customer
      })
      yield call(Alert.success, '<div>Customer info copied to reservation form two</div>')
    } else {
      yield put({
        type: 'PRELOAD_CUSTOMER_INFO_ERROR',
        errors: customerInfo['errors']
      })
    }
  } catch (error) {
    yield put({type: kegTypes.FAILURE, errors: error})
  }
}

export function* formOneSaga(action) {
  try {
    const form = yield* reservation_helpers.buildReservation()
    form['company_id'] = action.company_id
    const reservation = yield call(reduxFetch, ReservationEndpoint.create_keg_information(form))
    if (reservation['data']) {
      yield put({type: kegTypes.SUCCESS, order: reservation.data})
    } else {
      yield put({
        type: kegTypes.FAILURE,
        errors: reservation['errors']
      })
    }
  } catch (error) {
    console.log(error)
    yield call(Alert.warning, `<div> ${error['error'][0]} </div>`)
    yield put({type: kegTypes.FAILURE, errors: error})
  }
}

export function* formTwoSaga(action) {
  try {
    const form_object = yield select(selectors.form_two)
    const form = form_object.values
    form['order_id'] = yield select(selectors.order_id)
    form['return_date'] = yield select(selectors.return_date)
    form['birthdate'] = yield select(selectors.birthdate)
    form['company_id'] = action.company_id
    const reservation = yield call(reduxFetch, ReservationEndpoint.create_personal_information(form))
    if (reservation['data']) {
      yield put({
        type: personalInformation.SUCCESS,
        order: reservation.data,
        order_info: reservation.included
      })
    } else {
      yield put({
        type: personalInformation.FAILURE,
        errors: reservation['errors']
      })
    }
  } catch (error) {
    yield put({type: personalInformation.FAILURE, error})
  }
}

export function* killReservationSaga(action) {
  try {
    const form = {}
    let inventory_ids = []
    const number_of_kegs = yield select(selectors.number_of_kegs)
    const order_id = yield select(selectors.order_id)
    let i = 0
    while (i < number_of_kegs) {
      const keg_size = yield select(selectors.selected_keg_size, i)
      if (keg_size['value']['type'] === 'inventory') {
        inventory_ids.push(keg_size['value']['id'])
      }
      i++
    }

    form['inventory_ids'] = inventory_ids
    form['order_id'] = order_id || null

    const reservation = yield call(reduxFetch, ReservationEndpoint.cancel(form))
    if (reservation['data']) {
      yield put({
        type: 'KILL_SUCCESS',
        order: reservation.data,
      })
      yield put({
        type: 'RESET_FORMS'
      })
    } else {
      yield put({
        type: 'KILL_ERROR',
        errors: reservation['errors']
      })
      yield put({
        type: 'RESET_FORMS'
      })
    }
  } catch (error) {
    yield put({type: 'KILL_ERROR', error})
  }


}

export function* discountSaga(action) {
  try {
    let form = {}
    const form_object = yield select(selectors.discounts_form)

    form['discount'] = form_object && form_object['values'] && form_object['values']['discount']
    form['company_id'] = action.companyId
    form['order_id'] = action.orderId

    const orderDiscount = yield call(reduxFetch, ReservationEndpoint.applyDiscount(form))
    if (orderDiscount['data']) {
      yield put({type: 'DISCOUNT_SUCCESS', order: orderDiscount.data, order_info: orderDiscount.included})
    } else {
      yield put({
        type: 'DISCOUNT_ERROR',
        errors: orderDiscount['errors']
      })
    }
  } catch (error) {
    yield put({type: 'DISCOUNT_ERROR', errors: error})
  }
}

export function* publicInformationSaga(action) {
  try {
    const publicInfo = yield call(reduxFetch, CompanyEndpoint.publicInformation(action.company_id))
    if (publicInfo['data']) {
      let futureDate = publicInfo.data && publicInfo.data.attributes && publicInfo.data.attributes.waitForReservations
      yield put({
        type: 'PUBLIC_INFORMATION_SUCCESS',
        publicInfo: publicInfo.data,
        pick_up_date: moment().add(futureDate || 0, 'days'),
        return_date: moment().add(futureDate || 0, 'days')
      })
    } else {
      yield put({
        type: 'PUBLIC_INFORMATION_ERROR',
        errors: publicInfo['errors']
      })
    }
  } catch (error) {
    yield put({type: kegTypes.FAILURE, errors: error})
  }
}

export function* cheersPage(action) {
  try {
    let company_website = yield select(selectors.company_website)
    yield put(push({pathname: '/cheers', state: {website: company_website}}))
  } catch (error) {
  }
}

export function* verifySaga(action) {
  try {
    let form = {}
    form['company_id'] = action.companyId
    form['order_id'] = action.orderId

    const verify = yield call(reduxFetch, ReservationEndpoint.verifyReservation(form))
    if (verify['data']) {
      yield put({
        type: 'VERIFY_SUCCESS'
      })
    } else {
      yield put({
        type: 'VERIFY_ERROR',
        errors: verify['errors']
      })
    }
  } catch (error) {
    yield put({type: kegTypes.FAILURE, errors: error})
  }
}

export function* rootSaga() {
  yield takeLatest('PRELOAD_CUSTOMER_INFO', preloadCustomerInfoSaga)
  yield takeLatest('PUBLIC_INFORMATION', publicInformationSaga)
  yield takeLatest('SUBMIT_FORM_ONE', formOneSaga)
  yield takeLatest('SUBMIT_FORM_TWO', formTwoSaga)
  yield takeLatest('KILL_RESERVATION', killReservationSaga)
  yield takeLatest('SUBMIT_DISCOUNT', discountSaga)
  yield takeLatest('CHEERS_PAGE', cheersPage)
  yield takeLatest('VERIFY_RESERVATION', verifySaga)
}



// WEBPACK FOOTER //
// ./src/sagas/reservation.js